import type { DraftSlot } from '../../../../../drop-generator.types';
import { dropKey } from '../../../state/slots/group-keyed';
import type { SlotPatch } from '../../../state/slots/slot-ops';

/** A list-first choice also selects its linked group; a fixed list replaces a rank; automatic clears both. */
export function selectSlotList(slot: DraftSlot, groupId: string, listId: number | null): SlotPatch {
  const pins = { ...slot.listsByGroup };
  if (listId === null) delete pins[groupId];
  else pins[groupId] = listId;
  return {
    listGroupIds: slot.listGroupIds.includes(groupId) ? slot.listGroupIds : [...slot.listGroupIds, groupId],
    listsByGroup: Object.keys(pins).length ? pins : null,
    listsRankByGroup: dropKey(slot.listsRankByGroup, groupId),
  };
}

/** 19/10/2026 — tie the drop to the group's #rank list of the day (it follows the group); a fixed list goes. */
export function selectSlotRank(slot: DraftSlot, groupId: string, rank: number): SlotPatch {
  return {
    listGroupIds: slot.listGroupIds.includes(groupId) ? slot.listGroupIds : [...slot.listGroupIds, groupId],
    listsByGroup: dropKey(slot.listsByGroup, groupId),
    listsRankByGroup: { ...(slot.listsRankByGroup ?? {}), [groupId]: rank },
  };
}
